(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart"]) return;
  try {
    
  const initializeTumzaroCart = (cart) => {
    if (!cart || cart.dataset.cartReady === 'true') return;
    cart.dataset.cartReady = 'true';

    const form = cart.querySelector('[data-cart-form]');
    if (!form) return;

    const submitUpdate = () => {
      form.setAttribute('aria-busy', 'true');
      form.requestSubmit(form.querySelector('[data-cart-update]'));
    };

    cart.querySelectorAll('[data-cart-quantity]').forEach((button) => {
      button.addEventListener('click', () => {
        const input = button.parentElement.querySelector('[data-cart-input]');
        if (!input) return;
        const nextValue = Math.max(1, Number(input.value || 1) + Number(button.dataset.cartQuantity));
        if (nextValue === Number(input.value)) return;
        input.value = nextValue;
        submitUpdate();
      });
    });

    cart.querySelectorAll('[data-cart-input]').forEach((input) => {
      input.addEventListener('change', () => {
        input.value = Math.max(1, Number(input.value || 1));
        submitUpdate();
      });
    });
  };

  document.querySelectorAll('[data-tz-cart]').forEach(initializeTumzaroCart);
  document.addEventListener('shopify:section:load', (event) => {
    initializeTumzaroCart(event.target.querySelector('[data-tz-cart]'));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  document.addEventListener('change', (event) => {
    if (!event.target.matches('[data-collection-sort]')) return;
    event.target.form.requestSubmit();
  });

  document.addEventListener('click', (event) => {
    const filter = event.target.closest('[data-card-filter]');
    if (!filter) return;
    const values = filter.dataset.cardValues.split(',');
    const attribute = filter.dataset.cardFilter === 'tools' ? 'cardTools' : 'cardLocks';
    document.querySelectorAll('[data-card-filter]').forEach((button) => button.removeAttribute('aria-pressed'));
    filter.setAttribute('aria-pressed', 'true');
    document.querySelectorAll('.tz-collection__grid .tz-grid-card').forEach((card) => {
      card.closest('.tz-collection__grid > *').hidden = !values.includes(card.dataset[attribute]);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  const initializeTumzaroHeader = (header) => {
    if (!header || header.dataset.navigationReady === 'true') return;
    header.dataset.navigationReady = 'true';

    const desktopItems = [...header.querySelectorAll('[data-desktop-nav-item]')];
    const mobileMenu = header.querySelector('[data-mobile-menu]');
    const mobileToggle = header.querySelector('[data-mobile-menu-toggle]');
    const desktopMedia = window.matchMedia('(min-width: 900px)');
    const main = header.querySelector('.tz-site-header__main');
    const desktopTrigger = header.querySelector('[data-desktop-nav-item] .tz-site-header__nav-trigger');
    let closeTimer;
    let scrollFrame;

    const syncTop = () => {
      const mainBottom = main?.getBoundingClientRect().bottom || 0;
      header.style.setProperty('--tz-menu-top', `${mainBottom}px`);
      header.style.setProperty('--tz-desktop-menu-top', `${desktopTrigger?.getBoundingClientRect().bottom || mainBottom}px`);
    };

    const clearDesktopClose = () => {
      window.clearTimeout(closeTimer);
      closeTimer = undefined;
    };

    const syncMobile = () => {
      if (!mobileMenu || !mobileToggle) return;
      mobileToggle.setAttribute('aria-expanded', String(mobileMenu.open));
      mobileToggle.setAttribute('aria-label', mobileMenu.open ? mobileToggle.dataset.closeLabel : mobileToggle.dataset.openLabel);
      document.documentElement.classList.toggle('tz-mobile-menu-open', mobileMenu.open);
      if (mobileMenu.open) syncTop();
    };

    const closeMobile = (focus = false) => {
      if (!mobileMenu || !mobileToggle) return;
      const wasOpen = mobileMenu.open;
      mobileMenu.open = false;
      syncMobile();
      if (wasOpen && focus) requestAnimationFrame(() => mobileToggle.focus());
    };

    const setDesktop = (item, open) => {
      const toggle = item.querySelector('[data-desktop-nav-toggle]');
      const dropdown = item.querySelector('[data-desktop-nav-dropdown]');
      if (!toggle || !dropdown) return;
      item.toggleAttribute('data-open', open);
      if (!open) item.removeAttribute('data-click-open');
      toggle.setAttribute('aria-expanded', String(open));
      dropdown.setAttribute('aria-hidden', String(!open));
      if (open) syncTop();
    };

    const closeDesktop = (except) => {
      clearDesktopClose();
      desktopItems.forEach((item) => {
        if (item !== except) setDesktop(item, false);
      });
    };

    const scheduleDesktopClose = (item) => {
      clearDesktopClose();
      if (item.hasAttribute('data-click-open')) return;
      closeTimer = window.setTimeout(() => {
        if (!item.matches(':hover') && !item.contains(document.activeElement)) setDesktop(item, false);
      }, 180);
    };

    desktopItems.forEach((item) => {
      const toggle = item.querySelector('[data-desktop-nav-toggle]');
      const dropdown = item.querySelector('[data-desktop-nav-dropdown]');
      if (!toggle || !dropdown) return;

      item.addEventListener('pointerenter', (event) => {
        if (event.pointerType === 'touch' || !desktopMedia.matches) return;
        clearDesktopClose();
        closeDesktop(item);
        setDesktop(item, true);
      });

      item.addEventListener('pointerleave', (event) => {
        if (event.pointerType !== 'touch' && desktopMedia.matches) scheduleDesktopClose(item);
      });

      dropdown.addEventListener('pointerenter', clearDesktopClose);
      dropdown.addEventListener('pointerleave', () => scheduleDesktopClose(item));

      item.addEventListener('focusin', () => {
        if (!desktopMedia.matches) return;
        clearDesktopClose();
        closeDesktop(item);
        setDesktop(item, true);
      });

      item.addEventListener('focusout', (event) => {
        if (!item.contains(event.relatedTarget)) scheduleDesktopClose(item);
      });

      toggle.addEventListener('click', () => {
        clearDesktopClose();
        const shouldPin = !item.hasAttribute('data-click-open');
        closeDesktop(item);
        if (shouldPin) {
          item.setAttribute('data-click-open', '');
          setDesktop(item, true);
        } else {
          setDesktop(item, false);
        }
      });

      toggle.addEventListener('keydown', (event) => {
        if (event.key !== 'ArrowDown') return;
        event.preventDefault();
        clearDesktopClose();
        closeDesktop(item);
        setDesktop(item, true);
        dropdown.querySelector('a,button')?.focus();
      });
    });

    const activateTab = (tab, focus = false) => {
      const menu = tab.closest('.tz-mega-menu');
      if (!menu) return;
      menu.querySelectorAll('[data-mega-tab]').forEach((candidate) => {
        const active = candidate === tab;
        candidate.setAttribute('aria-selected', String(active));
        candidate.tabIndex = active ? 0 : -1;
      });
      menu.querySelectorAll('[data-mega-panel]').forEach((panel) => {
        panel.hidden = panel.dataset.megaPanel !== tab.dataset.megaTab;
      });
      if (focus) tab.focus();
    };

    header.querySelectorAll('[data-mega-tab]').forEach((tab) => {
      tab.addEventListener('click', () => activateTab(tab));
      tab.addEventListener('keydown', (event) => {
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        const tabs = [...tab.closest('.tz-mega-menu__tabs').querySelectorAll('[data-mega-tab]')];
        const index = tabs.indexOf(tab);
        let next = index;
        if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
        if (event.key === 'ArrowLeft') next = (index - 1 + tabs.length) % tabs.length;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = tabs.length - 1;
        activateTab(tabs[next], true);
      });
    });

    header.querySelectorAll('[data-mobile-nav-toggle]').forEach((toggle) => {
      toggle.addEventListener('click', () => {
        const item = toggle.closest('[data-mobile-nav-item]');
        const submenu = item?.querySelector('[data-mobile-nav-submenu]');
        if (!item || !submenu) return;
        const open = toggle.getAttribute('aria-expanded') !== 'true';
        item.toggleAttribute('data-open', open);
        toggle.setAttribute('aria-expanded', String(open));
        submenu.setAttribute('aria-hidden', String(!open));
      });
    });

    if (mobileMenu && mobileToggle) {
      mobileMenu.addEventListener('toggle', syncMobile);
      syncMobile();
    }

    const dialog = header.querySelector('[data-search-dialog]');
    const openSearch = header.querySelector('[data-search-open]');
    const closeSearch = header.querySelector('[data-search-close]');
    const input = header.querySelector('[data-predictive-input]');
    const results = header.querySelector('[data-predictive-results]');
    const initialResults = results?.innerHTML || '';
    let searchTimer;
    let controller;
    let lastQuery = '';

    const closeDialog = (focus = false) => {
      if (!dialog?.open) return;
      dialog.close();
      if (focus) requestAnimationFrame(() => openSearch?.focus());
    };

    openSearch?.addEventListener('click', () => {
      closeDesktop();
      closeMobile(false);
      syncTop();
      dialog?.showModal();
      requestAnimationFrame(() => input?.focus());
    });

    closeSearch?.addEventListener('click', () => closeDialog(true));
    dialog?.addEventListener('click', (event) => {
      if (event.target === dialog) closeDialog(true);
    });

    input?.addEventListener('input', () => {
      window.clearTimeout(searchTimer);
      const query = input.value.trim();
      input.setAttribute('aria-expanded', String(Boolean(query)));
      if (!query) {
        results.innerHTML = initialResults;
        lastQuery = '';
        return;
      }
      searchTimer = window.setTimeout(async () => {
        controller?.abort();
        controller = new AbortController();
        lastQuery = query;
        try {
          const url = `${results.dataset.endpoint}?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=4&resources[options][unavailable_products]=last&section_id=predictive-search`;
          const response = await fetch(url, { signal: controller.signal });
          if (!response.ok) throw new Error();
          const html = await response.text();
          if (input.value.trim() !== lastQuery) return;
          const parsed = new DOMParser().parseFromString(html, 'text/html');
          results.innerHTML = parsed.querySelector('[data-predictive-section]')?.innerHTML || '';
        } catch (error) {
          if (error.name !== 'AbortError') results.innerHTML = '';
        }
      }, 180);
    });

    document.addEventListener('pointerdown', (event) => {
      if (header.contains(event.target)) return;
      closeDesktop();
      closeMobile(true);
    });

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      if (dialog?.open) {
        event.preventDefault();
        closeDialog(true);
        return;
      }
      const openItem = header.querySelector('[data-desktop-nav-item][data-open]');
      if (openItem || mobileMenu?.open) event.preventDefault();
      const openToggle = openItem?.querySelector('[data-desktop-nav-toggle]');
      closeMobile(true);
      openToggle?.focus();
      closeDesktop();
    });

    desktopMedia.addEventListener('change', (event) => {
      if (event.matches) closeMobile(false);
      else closeDesktop();
    });

    window.addEventListener('resize', syncTop);
    window.addEventListener('scroll', () => {
      if (!header.querySelector('[data-desktop-nav-item][data-open]') || scrollFrame) return;
      scrollFrame = requestAnimationFrame(() => {
        syncTop();
        scrollFrame = undefined;
      });
    }, { passive: true });
  };

  document.querySelectorAll('[data-tz-header]').forEach(initializeTumzaroHeader);
  document.addEventListener('shopify:section:load', (event) => initializeTumzaroHeader(event.target.querySelector('[data-tz-header]')));
  document.addEventListener('shopify:section:unload', (event) => {
    if (event.target.querySelector('[data-tz-header]')) document.documentElement.classList.remove('tz-mobile-menu-open');
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  document.addEventListener('click', (event) => {
    const thumbnail = event.target.closest('[data-gallery-thumbnail]');
    if (thumbnail) {
      const gallery = thumbnail.closest('.tz-product__gallery');
      const mainImage = gallery.querySelector('.tz-product__main-image');
      if (!mainImage) return;
      mainImage.src = thumbnail.dataset.mediaSrc;
      mainImage.removeAttribute('srcset');
      mainImage.alt = thumbnail.dataset.mediaAlt;
      gallery.querySelectorAll('[data-gallery-thumbnail]').forEach((button) => {
        const active = button === thumbnail;
        button.classList.toggle('is-active', active);
        if (active) button.setAttribute('aria-current', 'true');
        else button.removeAttribute('aria-current');
      });
      return;
    }

    const quantityButton = event.target.closest('[data-quantity-change]');
    if (!quantityButton) return;
    const input = quantityButton.parentElement.querySelector('input');
    input.value = Math.max(1, Number(input.value || 1) + Number(quantityButton.dataset.quantityChange));
  });

  document.addEventListener('change', (event) => {
    if (!event.target.matches('[data-variant-select]')) return;
    const section = event.target.closest('[data-product-section]');
    const selectedOption = event.target.selectedOptions[0];
    const available = selectedOption.dataset.available === 'true';
    section.querySelector('[data-product-price]').textContent = selectedOption.dataset.price;
    const addButton = section.querySelector('[data-add-to-cart]');
    addButton.disabled = !available;
    section.querySelector('[data-add-label]').textContent = available ? section.dataset.addLabel : section.dataset.soldOutLabel;
    const url = new URL(window.location.href);
    url.searchParams.set('variant', event.target.value);
    window.history.replaceState({}, '', url);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tumzaro-faq-page"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.tz-faq-item').forEach((item)=>{const summary=item.querySelector('summary');const sync=()=>summary?.setAttribute('aria-expanded',String(item.open));item.addEventListener('toggle',sync);sync()});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tumzaro-tracking-page"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-tracking-page]').forEach((page)=>{if(page.dataset.ready)return;page.dataset.ready='true';const form=page.querySelector('[data-tracking-form]'),carrier=page.querySelector('[data-tracking-carrier]'),number=page.querySelector('[data-tracking-number]'),error=page.querySelector('[data-tracking-error]');const normalize=(value)=>value.replace(/[\s-]/g,'').toUpperCase();const patterns={usps:[/^\d{20,22}$/,/^[A-Z]{2}\d{9}US$/],ups:[/^1Z[A-Z0-9]{16}$/,/^\d{9,12}$/],fedex:[/^\d{12}$/, /^\d{15}$/, /^\d{20}$/, /^\d{22}$/],dhl:[/^\d{10}$/, /^JJD[A-Z0-9]{15,21}$/]};const validFor=(value,service)=>patterns[service]?.some((pattern)=>pattern.test(value));const identify=(value)=>{if(/^1Z[A-Z0-9]{16}$/.test(value))return'ups';if(/^[A-Z]{2}\d{9}US$/.test(value)||/^\d{20,22}$/.test(value))return'usps';if(/^\d{12}$/.test(value)||/^\d{15}$/.test(value))return'fedex';if(/^\d{10}$/.test(value)||/^JJD[A-Z0-9]{15,21}$/.test(value))return'dhl';return''};const showError=(message)=>{error.textContent=message;error.hidden=false;number.setAttribute('aria-invalid','true');number.focus()};number?.addEventListener('input',()=>{if(number.value.trim()){error.hidden=true;number.removeAttribute('aria-invalid')}});form?.addEventListener('submit',(event)=>{event.preventDefault();const raw=number.value.trim();if(!raw){showError(error.dataset.emptyMessage);return}const tracking=normalize(raw),selected=carrier.value==='auto'?identify(tracking):carrier.value;if(!selected||!validFor(tracking,selected)){showError(error.dataset.invalidMessage);return}error.hidden=true;number.removeAttribute('aria-invalid');const encoded=encodeURIComponent(tracking);const destinations={usps:`https://tools.usps.com/go/TrackConfirmAction?tLabels=${encoded}`,ups:`https://www.ups.com/track?loc=en_US&tracknum=${encoded}`,fedex:`https://www.fedex.com/fedextrack/?trknbr=${encoded}`,dhl:`https://www.dhl.com/us-en/home/tracking/tracking-express.html?submit=1&tracking-id=${encoded}`};window.location.assign(destinations[selected])})});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["v22-collection"] && !Shopify.designMode) return;
  try {
    
(function(){
  function normalize(value){return (value||'').replace(/\s+/g,' ').trim().toLowerCase()}
  function enhanceCollectionFaq(scope){
    var roots=(scope||document).querySelectorAll('.alp-collection-seo:not([data-v22-faq-ready])');
    Array.prototype.forEach.call(roots,function(root){
      var source=root.querySelector('.alp-collection-seo-copy');
      if(!source)return;
      var children=Array.prototype.slice.call(source.children);
      var items=[];
      children.forEach(function(node,index){
        if(node.tagName!=='H2'&&node.tagName!=='H3')return;
        if(normalize(node.textContent)==='frequently asked questions')return;
        var body=[];
        for(var cursor=index+1;cursor<children.length;cursor++){
          if(children[cursor].tagName==='H2'||children[cursor].tagName==='H3')break;
          body.push(children[cursor]);
        }
        items.push({heading:node,body:body});
      });
      if(!items.length)return;

      var layout=document.createElement('section');
      layout.className='v22-collection-faq';
      layout.setAttribute('aria-label','Collection frequently asked questions');

      var intro=document.createElement('div');
      intro.className='v22-collection-faq__intro';
      var eyebrow=document.createElement('p');
      eyebrow.className='v22-collection-faq__eyebrow';
      eyebrow.textContent='BEFORE YOU CHOOSE';
      var title=document.createElement('h2');
      title.className='v22-collection-faq__title';
      title.appendChild(document.createTextNode((root.dataset.v22FaqTitle||'').trim()+' '));
      var titleAccent=document.createElement('span');
      titleAccent.textContent='FAQ';
      title.appendChild(titleAccent);
      intro.appendChild(eyebrow);
      intro.appendChild(title);

      var listWrap=document.createElement('div');
      listWrap.className='v22-collection-faq__content';
      var meta=document.createElement('div');
      meta.className='v22-collection-faq__meta';
      var metaLabel=document.createElement('span');
      metaLabel.textContent='THE DETAILS, MADE CLEAR.';
      var metaCount=document.createElement('span');
      metaCount.textContent='01–'+String(items.length).padStart(2,'0');
      meta.appendChild(metaLabel);
      meta.appendChild(metaCount);
      listWrap.appendChild(meta);

      var list=document.createElement('div');
      list.className='v22-collection-faq__list';
      items.forEach(function(item,index){
        var details=document.createElement('details');
        details.className='v22-collection-faq__item';
        if(index===0)details.open=true;
        var summary=document.createElement('summary');
        summary.className='v22-collection-faq__summary';
        var number=document.createElement('span');
        number.className='v22-collection-faq__number';
        number.textContent=String(index+1).padStart(2,'0');
        var question=document.createElement('span');
        question.className='v22-collection-faq__question';
        question.innerHTML=item.heading.innerHTML;
        var icon=document.createElement('span');
        icon.className='v22-collection-faq__icon';
        icon.setAttribute('aria-hidden','true');
        summary.appendChild(number);
        summary.appendChild(question);
        summary.appendChild(icon);
        var answer=document.createElement('div');
        answer.className='v22-collection-faq__answer';
        item.body.forEach(function(node){answer.appendChild(node)});
        details.appendChild(summary);
        details.appendChild(answer);
        list.appendChild(details);
      });
      listWrap.appendChild(list);
      layout.appendChild(intro);
      layout.appendChild(listWrap);
      root.replaceChildren(layout);
      root.dataset.v22FaqReady='true';
    });
  }
  function boot(){enhanceCollectionFaq(document)}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);else boot();
  document.addEventListener('shopify:section:load',function(event){enhanceCollectionFaq(event.target)});
})();

  } catch(e) { console.error(e); }
})();
})();
